import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

interface DeleteCustomFieldArguments {
  params: OpalApiRequestParams<'DeleteCustomFieldV3'>
}

// The CustomField Delete endpoint does not return data,
// only a response with a `204` status code. Because
// of that, we will hard code `null` as the response
export async function deleteCustomField({
  params,
}: DeleteCustomFieldArguments): Promise<null> {
  const url = new URL(
    `/loupe/v3/custom_fields/${params.path.custom_field_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
